module.exports = __webpack_public_path__ + "static/media/globe.3f30c62f.svg";